import React from 'react'

export const MenuIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg'
    style={props.style} className='icon--menu'
    viewBox='-289 381 32 32'
  >
    <path
      d='M-564.1,787.5c-6.4,0-11.6-5.2-11.6-11.6c0-6.4,5.2-11.6,11.6-11.6c6.4,0,11.6,5.2,11.6,11.6 C-552.5,782.3-557.7,787.5-564.1,787.5z M-564.1,767c-4.9,0-9,4.1-9,9s4,9,9,9c4.9,0,9-4,9-9S-559.2,767-564.1,767z'
    />
    <path
      d='M-549.6,791.8c-0.3,0-0.7-0.1-0.9-0.4l-7.3-7.3c-0.5-0.5-0.5-1.3,0-1.8s1.3-0.5,1.8,0l7.3,7.3c0.5,0.5,0.5,1.3,0,1.8C-548.9,791.8-549.2,791.8-549.6,791.8z'
    />
    <path
      d='M-258.6,409.2c0,1-0.8,1.8-1.8,1.8h-25.2c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8h25.2 C-259.4,407.5-258.6,408.3-258.6,409.2z M-260.4,395.6h-25.2c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8h25.2c1,0,1.8-0.8,1.8-1.8 C-258.6,396.4-259.4,395.6-260.4,395.6z M-285.6,387.3h25.2c1,0,1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8h-25.2c-1,0-1.8,0.8-1.8,1.8 S-286.6,387.3-285.6,387.3z'
    />
  </svg>
)
